import React, {useState} from "react";
import {SliderMarks} from "antd/lib/slider";
import {ICommentDetails} from "@Models/IActivityDetails";

const VideoWrapperHooks = () => {
    const [commentsState, setCommentsState] = useState<ICommentDetails[]>([]);
    const [marksState, setMarksState] = useState<SliderMarks>({0: '', 100: ''});
    const [progressState, setProgressState] = useState<number>(0);
    const [durationState, setDurationState] = useState<number>(0);

    return {
        commentsState,
        setCommentsState,
        marksState,
        setMarksState,
        progressState,
        setProgressState,
        durationState,
        setDurationState
    };
};
export default VideoWrapperHooks;